<template>
  <div class="sort-by">
    <div class="flex flex-wrap w-full">
      <div class="spacer-x-1 sort-by__label">
        <p>Sort By:</p>
      </div>
      <div class="flex-shrink-0 sort-by__dropdown">
        <div class="dropdown">
          <button class="btn btn-block btn-default dropdown-toggle w-full" type="button" id="billboard-sort-by" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            {{ sortAndOrderBy.label }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="billboard-sort-by">
            <li v-for="(option, index) in options" :key="index">
              <router-link
                :to="{ query: routerLinkQueryForOption(option) }"
                @click.native="sortAndOrderBy = option">
                {{ option.label }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { find, assign } from 'lodash'

export default {
  props: {
    setFilterMutation: {
      required: true,
      type: Function
    },
    filters: {
      required: true,
      type: Object
    },
    options: {
      required: false,
      type: Array,
      default () {
        let sortOptions = [
          {
            label: 'Most Recent Message',
            sort: 'latest_post_at',
            order: 'desc'
          },
          {
            label: 'Least Recent Message',
            sort: 'latest_post_at',
            order: 'asc'
          },
          {
            label: 'Furthest Event Date',
            sort: 'bookings.date',
            order: 'desc'
          },
          {
            label: 'Soonest Event Date',
            sort: 'bookings.date',
            order: 'asc'
          },
          {
            label: 'Unread Messages',
            sort: 'unread_count',
            order: 'desc'
          }
        ]
        return sortOptions
      }
    }
  },

  computed: {
    sortAndOrderBy: {
      get () {
        return find(this.options, (option) => {
          return option.sort === this.filters.sort &&
            option.order === this.filters.order
        })
      },

      set ({ sort, order }) {
        this.setFilterMutation({ filter: 'sort', value: sort })
        this.setFilterMutation({ filter: 'order', value: order })
      }
    }
  },

  methods: {
    routerLinkQueryForOption (option) {
      return assign({}, this.$route.query, {
        sort: option.sort,
        order: option.order
      })
    }
  }
}
</script>
